export { default as GeneralInformation } from './GeneralInformation';
export { default as Preferences } from './Preferences';
export { default as ResetPassword } from './ResetPassword';
export { default as SocialsInformation } from './SocialsInformation';